var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CompTable',{ref:"comp_table",attrs:{"title":(_vm.orgName || '') + '逾期更新栏目清单',"columns":_vm.columns,"table-api":_vm.tableApi}})}
var staticRenderFns = []

export { render, staticRenderFns }